/* app/js/src/components/mam-explorer/mam-explorer-status-cell/mam-explorer-status-cell.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.mam-status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.status--ready {
  background-color: rgba(0, 202, 105, 0.08);
  color: rgb(0, 133, 69);
}
.status--processing {
  background-color: rgba(255, 180, 0, 0.08);
  color: rgb(163, 115, 0);
}
.status--deleted {
  background-color: rgba(255, 76, 81, 0.08);
  color: rgb(163, 49, 52);
}
/*# sourceMappingURL=mam-explorer-status-cell.component.css.map */
